import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Modal } from '@gouvfr-lasuite/cunningham-react';

import GeneralPane from './GeneralPane';

const ProjectSettingsModal = React.memo(
  ({
    name,
    roleAssignments,
    projectManagerRole,
    currentProjectId,
    searchedUsers,
    isSearchingUsers,
    onUpdate,
    onDelete,
    onRoleAssignmentCreate,
    onRoleAssignmentDelete,
    onClose,
    onSearchUsers,
    onClearUserSearch,
  }) => {
    const [t] = useTranslation();

    return (
      <Modal
        isOpen
        title={t('common.projectSettings')}
        closeIcon
        onClose={onClose}
        closeOnClickOutside
      >
        <GeneralPane
          name={name}
          roleAssignments={roleAssignments}
          searchedUsers={searchedUsers}
          projectManagerRole={projectManagerRole}
          currentProjectId={currentProjectId}
          isSearchingUsers={isSearchingUsers}
          onUpdate={onUpdate}
          onDelete={onDelete}
          onRoleAssignmentCreate={onRoleAssignmentCreate}
          onRoleAssignmentDelete={onRoleAssignmentDelete}
          onSearchUsers={onSearchUsers}
          onClearUserSearch={onClearUserSearch}
        />
      </Modal>
    );
  },
);

ProjectSettingsModal.propTypes = {
  name: PropTypes.string.isRequired,
  /* eslint-disable react/forbid-prop-types */
  roleAssignments: PropTypes.array.isRequired,
  projectManagerRole: PropTypes.array.isRequired,
  currentProjectId: PropTypes.number.isRequired,
  searchedUsers: PropTypes.array.isRequired,
  isSearchingUsers: PropTypes.bool.isRequired,
  /* eslint-enable react/forbid-prop-types */
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onRoleAssignmentCreate: PropTypes.func.isRequired,
  onRoleAssignmentDelete: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSearchUsers: PropTypes.func.isRequired,
  onClearUserSearch: PropTypes.func.isRequired,
};

ProjectSettingsModal.defaultProps = {};

export default ProjectSettingsModal;
